import { FunctionComponent, useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import authentication from '../../../models/authentication';
import { RouterHookParams } from '../../../types';

interface ProtectedRouteProps {
  loggedIn: boolean;
  path: string;
  skipAuthentication: boolean;
  onEnterRoute: (params: RouterHookParams) => void;
  routeName: string;
}

const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = props => {
  const { loggedIn, onEnterRoute, routeName, path, skipAuthentication, children } = props;

  const location = useLocation();
  const params = useParams();

  // We cannot trigger onEnterRoute() in render of a route because updating the state in render is causing an error
  // "Cannot update a component from inside the function body of a different component."
  useEffect(() => {
    const routerParams: RouterHookParams = {
      queryParams: Object.fromEntries(new URLSearchParams(location.search)),
      pathParams: params,
      routeName,
    };

    onEnterRoute(routerParams);
    // Always scroll to the top
    window.scrollTo(0, 0);
  }, [location, onEnterRoute, path, params, routeName]);

  if (loggedIn || skipAuthentication) {
    return <>{children}</>;
  } else {
    // user got here by deep link, but is not logged in yet - update last location to return to original target eventually
    authentication.setLastLocation();
    return <Navigate to="/login" />;
  }
};

export default ProtectedRoute;
